<template>
    <div class="reg-temp-content-area main-content-height p-5">
        <div v-if="modalData.active" class="custom-popup-modal  active">
            <div class="custom-modal-wrapper">
                <div class="customer-model-content add-new-product-model text-white">
                    <button class="close-btn" @click.prevent="closeModal">X</button>
                    <div class="login-content add-product-wrapper">
                        <div class="w-full">
                            <h3 class="mb-2 text-left  w-full">{{ modalData.obj.company }}</h3>
                        </div>
                        <table class="table">
                            <tr>
                                <td class="text-white text-left">Name</td>
                                <td class="text-white text-left">
                                    {{ modalData.obj.fname + ' ' + modalData.obj.lname }}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-white text-left">Email:</td>
                                <td class="text-white text-left">
                                    <a class="text-white" :href="'mailto:' + (modalData.obj.email ? modalData.obj.email : '#')">{{
                                        modalData.obj.email ? modalData.obj.email : ''
                                    }}</a>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-white text-left">Mobile:</td>
                                <td class="text-white text-left">{{ modalData.obj.mobile ? modalData.obj.mobile : '' }}</td>
                            </tr>
                            <tr>
                                <td class="text-white text-left">Address:</td>
                                <td class="text-white text-left">{{ modalData.obj.address ? modalData.obj.address : '' }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 col-md-12  mb-2 mt-2">
                <div class="row">
                    <div class="col-sm-12  col-md-12  col-lg-12" v-if="!loadingDistributor">
                        <h4>Select Depot</h4>
                        <div>
                            <ul class="reset depos-list">
                                <li class="mb-3">
                                    <a
                                        href="#"
                                        @click.self.prevent="fetchReseller('')"
                                        :class="'btn  ' + (activeDepot == '' ? 'btn-secondary' : 'btn-primary')"
                                        >All Depots</a
                                    >
                                </li>
                                <li v-bind:key="dep.id + 'depo'" class="mb-3" v-for="dep in distributors">
                                    <a
                                        href="#"
                                        @click.self.prevent="fetchReseller(dep.id)"
                                        :class="'btn  ' + (activeDepot == dep.id ? 'btn-secondary' : 'btn-primary')"
                                        >{{ dep.company }}</a
                                    >
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-sm-12  col-md-12  col-lg-12" v-else>
                        <loading />
                    </div>
                </div>
            </div>

            <div class="col-sm-12 col-md-12 mb-2 mt-2">
                <Loading v-if="loadingReseller" />
                <div v-if="resellers.length > 0">
                    <GmapMap :center="center" :zoom="7" style="width: 100%; height: calc(100vh - 120px)" v-bind:options="mapStyle">
                        <GmapMarker
                            :key="index"
                            v-for="(m, index) in resellers"
                            :position="m.position"
                            :clickable="true"
                            @click="toggleInfoWindow(m)"
                            @mouseover="showByIndex = index"
                            @mouseout="showByIndex = null"
                        >
                            <gmap-info-window :opened="showByIndex === index">
                                {{ m.company ? m.company : '' }}
                            </gmap-info-window>
                        </GmapMarker>
                    </GmapMap>
                </div>
            </div>

            <!-- <div class="col-sm-12 col-md-12 col-lg-12 text-center"  v-if="loading">
            <loading/>
          </div> -->
        </div>
    </div>
</template>

<script>
import AuthApis from '@/controllers/AuthApis';
import Env from '@/env';
import {mapGetters, mapActions} from 'vuex';
import Loading from '../../components/Loading.vue';

export default {
    name: 'superadminResellerList',
    components: {
        Loading
    },
    data() {
        return {
            loadCount: 0,
            loadingDistributor: false,
            loadingReseller: false,
            distributors: [],
            resellers: [],
            activeDepot: '',

            mapStyle: {
                styles: [
                    {
                        elementType: 'geometry',
                        stylers: [
                            {
                                color: '#ebe3cd'
                            }
                        ]
                    },
                    {
                        elementType: 'labels.text.fill',
                        stylers: [
                            {
                                color: '#523735'
                            }
                        ]
                    },
                    {
                        elementType: 'labels.text.stroke',
                        stylers: [
                            {
                                color: '#f5f1e6'
                            }
                        ]
                    },
                    {
                        featureType: 'administrative',
                        elementType: 'geometry.stroke',
                        stylers: [
                            {
                                color: '#c9b2a6'
                            }
                        ]
                    },
                    {
                        featureType: 'administrative.land_parcel',
                        elementType: 'geometry.stroke',
                        stylers: [
                            {
                                color: '#dcd2be'
                            }
                        ]
                    },
                    {
                        featureType: 'administrative.land_parcel',
                        elementType: 'labels.text.fill',
                        stylers: [
                            {
                                color: '#ae9e90'
                            }
                        ]
                    },
                    {
                        featureType: 'landscape.natural',
                        elementType: 'geometry',
                        stylers: [
                            {
                                color: '#f0f1f2'
                            }
                        ]
                    },
                    {
                        featureType: 'poi',
                        elementType: 'geometry',
                        stylers: [
                            {
                                color: '#f0f1f2'
                            }
                        ]
                    },
                    {
                        featureType: 'poi',
                        elementType: 'labels.text.fill',
                        stylers: [
                            {
                                color: '#93817c'
                            }
                        ]
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'geometry.fill',
                        stylers: [
                            {
                                color: '#a5b076'
                            }
                        ]
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'labels.text.fill',
                        stylers: [
                            {
                                color: '#447530'
                            }
                        ]
                    },
                    {
                        featureType: 'road',
                        elementType: 'geometry',
                        stylers: [
                            {
                                color: '#f5f1e6'
                            }
                        ]
                    },
                    {
                        featureType: 'road.arterial',
                        elementType: 'geometry',
                        stylers: [
                            {
                                color: '#fdfcf8'
                            }
                        ]
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'geometry',
                        stylers: [
                            {
                                color: '#f8c967'
                            }
                        ]
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'geometry.stroke',
                        stylers: [
                            {
                                color: '#e9bc62'
                            }
                        ]
                    },
                    {
                        featureType: 'road.highway.controlled_access',
                        elementType: 'geometry',
                        stylers: [
                            {
                                color: '#e98d58'
                            }
                        ]
                    },
                    {
                        featureType: 'road.highway.controlled_access',
                        elementType: 'geometry.stroke',
                        stylers: [
                            {
                                color: '#db8555'
                            }
                        ]
                    },
                    {
                        featureType: 'road.local',
                        elementType: 'labels.text.fill',
                        stylers: [
                            {
                                color: '#806b63'
                            }
                        ]
                    },
                    {
                        featureType: 'transit.line',
                        elementType: 'geometry',
                        stylers: [
                            {
                                color: '#f0f1f2'
                            }
                        ]
                    },
                    {
                        featureType: 'transit.line',
                        elementType: 'labels.text.fill',
                        stylers: [
                            {
                                color: '#8f7d77'
                            }
                        ]
                    },
                    {
                        featureType: 'transit.line',
                        elementType: 'labels.text.stroke',
                        stylers: [
                            {
                                color: '#ebe3cd'
                            }
                        ]
                    },
                    {
                        featureType: 'transit.station',
                        elementType: 'geometry',
                        stylers: [
                            {
                                color: '#f0f1f2'
                            }
                        ]
                    },
                    {
                        featureType: 'water',
                        elementType: 'geometry.fill',
                        stylers: [
                            {
                                color: '#b9d3c2'
                            }
                        ]
                    },
                    {
                        featureType: 'water',
                        elementType: 'labels.text.fill',
                        stylers: [
                            {
                                color: '#92998d'
                            }
                        ]
                    }
                ]
            },
            showByIndex: null,
            modalData: {
                obj: {},
                active: false
            },
            center: {
                lat: -26.3104228,
                lng: 28.046419
            },

            infoContent: '',
            infoWindowPos: null,
            infoWinOpen: true,
            currentMidx: null,
            //optional: offset infowindow so it visually sits nicely on top of our marker
            infoOptions: {
                pixelOffset: {
                    width: 0,
                    height: -35
                }
            }
        };
    },
    computed: {},
    created() {},
    watch: {},
    mounted() {
        this.fetchDepos();
    },
    methods: {
        /**
         * Fetch depos
         */
        fetchDepos() {
            this.loading = true;
            const url = `${Env.baseUrl}/superadmin/users/all?page=1`;
            AuthApis.postApi(url, {
                type: 'distributor'
            })
                .then(res => {
                    this.distributors = res.data.payload;
                    this.loading = false;
                    this.fetchReseller('');
                })
                .catch(err => {
                    console.log(err);
                    this.loading = true;
                });
        },

        fetchReseller(id) {
            this.activeDepot = id;

            this.resellers = [];

            if (id == '') {
                //  fetch all resellers

                this.loadingReseller = true;
                const url = `${Env.baseUrl}/superadmin/reseller/list-all-resellers`;
                AuthApis.getApi(url)
                    .then(res => {
                        res.data.payload.map(m => {
                            if (m.user_metas.lat && m.user_metas.lng) {
                                this.center = {
                                    lat: parseFloat(m.user_metas.lat),
                                    lng: parseFloat(m.user_metas.lng)
                                };
                                m.position = {
                                    lat: parseFloat(m.user_metas.lat),
                                    lng: parseFloat(m.user_metas.lng)
                                };
                                m.infoText = m.fname;
                            }
                        });
                        this.resellers = res.data.payload;
                        this.loadingReseller = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.loadingReseller = true;
                    });
            } else {
                this.loadingReseller = true;
                const url = `${Env.baseUrl}/superadmin/distributor/all-by-id`;
                AuthApis.postApi(url, {
                    id
                })
                    .then(res => {
                        res.data.payload.map(m => {
                            if (m.user_metas.lat && m.user_metas.lng) {
                                this.center = {
                                    lat: parseFloat(m.user_metas.lat),
                                    lng: parseFloat(m.user_metas.lng)
                                };
                                m.position = {
                                    lat: parseFloat(m.user_metas.lat),
                                    lng: parseFloat(m.user_metas.lng)
                                };
                                m.infoText = m.fname;
                            }
                        });
                        this.resellers = res.data.payload;
                        this.loadingReseller = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.loadingReseller = true;
                    });
            }
        },

        closeModal() {
            this.modalData = {
                obj: {},
                active: false
            };
        },

        toggleInfoWindow(m) {
            this.modalData = {
                obj: m,
                active: true
            };
        },

        ...mapActions({
            va_pdfModal: 'pdf/setActive',
            va_pdfModalObj: 'pdf/setActiveObj'
        })
    }
};
</script>
